import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/views/Home";
import Login from "@/views/Login";
import store from "@/store";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: "/herramientatic/",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: (to, from, next) => {
        if (to.path === "/login") next();
        store.state.user ? next() : next("/login");
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/logout",
      beforeEnter: (to, from, next) => {
        next("/");
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
